<p-dialog [(visible)]="visible" (onHide)="onDialogHide()" [modal]="true" appendTo="body"
          [style]="{'width': '960px', 'height': '800px'}">

	<p-header>
		<span>Edit Device Group</span>
	</p-header>

	<div style="overflow: hidden;">
		<device-group [target]="target" [network]="network" [filterPreviewModal]="false"
					  (onChanges)="detectChanges()"></device-group>
	</div>

	<p-footer>
		<button type="button" pButton icon="fa fa-check" [disabled]="!enableOk" (click)="onOkClicked()" label="OK"></button>
		<button type="button" pButton icon="fa fa-close" (click)="onCancelClicked()" label="Cancel"></button>
	</p-footer>

</p-dialog>
